import axios from "axios";
import api from "@/api";
import {
    REQUEST_SCCUESS_CODE,
    VUE_APP_IMG_BUCKET_NAME,
    VUE_APP_IMG_BUCKET_REGION,
} from "@/constant";

export const uploadImgToS3 = async (
    option: {
        file: any;
        maxFileSize: number;
        bucketName: string;
    },
    uploadProgress?: any
) => {
    const { file, maxFileSize, bucketName } = option;
    if (file.size > maxFileSize) {
        return {
            success: false,
            file: file,
            message: "file size is too large. Max file size is 1000MB.",
        };
    }
    const fileName = `${Date.now()}-${file.name}`;
    try {
        const res: any = await api.fetchUploadFileSign({ fileName: fileName });
        let presignedUrl = "";
        if (res?.code === REQUEST_SCCUESS_CODE) {
            presignedUrl = res?.msg;
        }
        try {
            const response: any = await axios.put(presignedUrl, file, {
                onUploadProgress: (progressEvent: any) => {
                    uploadProgress && uploadProgress(progressEvent, file);
                },
            });
            if (response?.status === 200) {
                const bucketNameStr = bucketName || VUE_APP_IMG_BUCKET_NAME;
                const region = VUE_APP_IMG_BUCKET_REGION;
                const accessUrl = `https://${bucketNameStr}.s3.${region}.amazonaws.com/${fileName}`;
                return {
                    success: true,
                    message: "uploaded successfully.",
                    location: accessUrl,
                    file: file,
                };
            } else {
                // console.error("Upload failed.");
                return {
                    success: false,
                    message: "Upload failed.",
                    file: file,
                };
            }
        } catch (error) {
            // console.error("Error uploading file: ", error);
            return {
                success: false,
                message: "Error occurred during image upload.",
                file: file,
            };
        }
    } catch (error) {
        // console.error("Error uploading file: ", error);
        return {
            success: false,
            message: "Error occurred during image upload.",
            file: file,
        };
    }
};
